module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M7.667 12H2v8H0V0h12l.333 2H20l-3 6 3 6H8l-.333-2z\"/></svg>"